<template>
  <div>
    <page-header :breadcrumb="breadcrumb"></page-header>
    <div class="page-view">
      <router-view />
    </div>
  </div>
</template>

<script>
import PageHeader from '../components/PageHeader';
const menuList = {
  Direct: [
    {
      key: 'AddDirect',
      ico: 'form',
      title: '下发指令'
    },
    {
      key: 'DirectList',
      ico: 'folder',
      title: '指令列表'
    }
  ],
  Report: [
    {
      key: 'AddReport',
      ico: 'form',
      title: '添加报题'
    },
    {
      key: 'ReportList',
      ico: 'folder',
      title: '报题列表'
    }
  ],
  Task: [
    // {
    //     key: 'AddTag',
    //     title: '添加标引',
    //     ico: 'form'
    // },
    {
      key: 'TagList',
      title: '标引列表',
      ico: 'form'
    },
    {
      key: 'AddTask',
      title: '添加任务',
      ico: 'form'
    },
    {
      key: 'TaskList',
      title: '任务列表',
      ico: 'form'
    },
    {
      key: 'AddTaskProgress',
      title: '上报我的任务进度',
      ico: 'form'
    },
    {
      key: 'TaskProgressList',
      title: '我的任务执行记录',
      ico: 'form'
    }
    // {
    //     key: 'TaskDetail',
    //     title: '任务详情',
    //     ico: 'form'
    // },
  ],
  Draft: [
    {
      key: 'AddArticle',
      title: '添加任务稿件',
      ico: 'form'
    },
    {
      key: 'ArticleList',
      title: '任务稿件列表',
      ico: 'form'
    }
  ],
  Article: [
    {
      key: 'Add',
      ico: 'form',
      title: '添加文章'
    },
    {
      key: 'Lists',
      ico: 'folder',
      title: '稿件库'
    },
    {
      key: 'Cate',
      ico: 'profile',
      title: '栏目管理'
    },
    // {
    //   key: "Special",
    //   ico: "star",
    //   title: "专题管理"
    // },
    {
      key: 'Sort',
      ico: 'ordered-list',
      title: '文章排序'
    },
    {
      key: 'updateIndex',
      ico: 'cloud-sync',
      title: '更新首页'
    },
    {
      key: 'Map',
      ico: 'cloud-sync',
      title: '栏目映射'
    },
    {
      key: 'Pend',
      ico: 'folder',
      title: '待审稿库'
    },
    {
      key: 'Imp',
      ico: 'folder',
      title: '批量导入'
    }
  ],
  Cloud: [
    {
      key: 'Picture',
      ico: 'picture',
      title: '图片库'
    },
    {
      key: 'Video',
      ico: 'video-camera',
      title: '多媒体库'
    },
    {
      key: 'Audio',
      ico: 'audio',
      title: '音频库'
    }
  ],
  Data: [
    {
      key: 'Wechat',
      ico: 'wechat',
      title: '微信',
      children: [
        {
          key: 'Wx',
          title: '最新文章'
        },
        {
          key: 'Gzh',
          title: '公众号列表'
        }
      ]
    },
    {
      key: 'YcNumber',
      ico: 'solution',
      title: '媒体号'
    },
    {
      key: 'Bigdata?id=4',
      ico: 'slack',
      title: '互联网信息'
    },
    {
      key: 'Bigdata?id=1',
      ico: 'audit',
      title: '宣传指令'
      // }, {
      //     key: 'Bigdata?id=2',
      //     ico: 'message',
      //     title: '记者线索',
      // }, {
      //     key: 'Bigdata?id=3',
      //     ico: 'snippets',
      //     title: '通讯员来稿',
    }
  ],
  Manage: [
    // {
    //   key: "SiteList",
    //   ico: "picture",
    //   title: "站点列表"
    // },
    {
      key: 'Census',
      ico: 'bar-chart',
      title: '数据统计'
    },
    {
      key: 'EditUser',
      ico: 'solution',
      title: '修改资料'
    },
    {
      key: 'SiteCache',
      ico: 'thunderbolt',
      title: '站点缓存'
    }
  ],
  Third: [
    {
      key: 'MediaPublishSetting',
      ico: 'deployment-unit',
      title: '媒体发布'
    }
  ],
  App: [
    {
      key: 'Setting',
      ico: 'setting',
      title: '系统设置'
    },
    {
      key: 'SplashPage',
      ico: 'instagram',
      title: '开屏广告'
    }
  ],
  ThirdParty: [
    {
      key: 'Services',
      ico: 'hdd',
      title: '服务管理'
    },
    {
      key: 'Tel',
      ico: 'phone',
      title: '便民电话'
    }
  ],
  Advertisement: [
    {
      key: 'Manage',
      ico: 'hdd',
      title: '物料管理'
    },
    {
      key: 'Position',
      ico: 'layout',
      title: '广告位管理'
    },
    {
      key: 'PutIn',
      ico: 'switcher',
      title: '投放管理'
    }
  ],
  Thematic: [
    // {
    //   key: 'List',
    //   ico: 'hdd',
    //   title: '模板列表'
    // },
    {
      key: 'Drag',
      ico: 'form',
      title: '专题编辑'
    },
    {
      key: 'Topic',
      ico: 'container',
      title: '专题列表'
    },
    {
      key: 'Picture',
      ico: 'hdd',
      title: '模板图片'
    }
  ],
  CateManage: [
    {
      key: 'GroupManger',
      ico: 'usergroup-add',
      title: '用户组管理'
    },
    {
      key: 'UserManger',
      ico: 'user',
      title: '用户管理'
    },
    {
      key: 'Authority',
      ico: 'audit',
      title: '栏目权限'
    }
  ],
  RegionArticle: [
    {
      key: 'ArticleListTop',
      ico: 'folder',
      title: '文章列表'
    }
  ],
  Mobile: [
    {
      key: 'AppList',
      ico: 'ordered-list',
      title: '广告列表'
    },
    {
      key: 'AppPush',
      ico: 'mobile',
      title: '文章推送'
    }
  ],
  WxPull: [
    {
      key: 'Channel',
      ico: 'ordered-list',
      title: '公众号分类'
    },
    {
      key: 'Article',
      ico: 'switcher',
      title: '文章列表'
    }
  ],
  Logs: [
    {
      key: 'Examine',
      ico: 'ordered-list',
      title: '查看日志'
    }
  ]
};
export default {
  name: 'PageLayout',
  components: { PageHeader },
  props: ['desc', 'logo', 'title', 'avatar', 'linkList', 'extraImage'],
  data() {
    return {
      breadcrumb: [],
      menuList,
      indexCache: false,
      role_id: 0,
      siteid: 0
    };
  },
  computed: {
    // layout() {
    //     return this.$store.state.setting.layout
    // }
  },
  created() {
    this.siteinfo();
    this.siteid = JSON.parse(window.localStorage.getItem('siteinfo')).site_id;
  },
  updated() {
    this.getBreadcrumb();
  },
  methods: {
    async siteinfo() {
      let res = await this.$http.post('/api/Snapshot/getCacheStatus');
      this.role_id = JSON.parse(localStorage.getItem('siteinfo')).role_id;
      if (res.data.state == 200) {
        this.indexCache = res.data.data.cache == 0 ? false : true;
        this.getBreadcrumb();
      }
    },
    getBreadcrumb() {
      this.breadcrumb = this.$route.matched;
      const model = this.$route.matched[1].path.slice(6);
      const pathArr = this.$route.matched[
        this.$route.matched.length - 1
      ].path.split('/');
      const defaultSelectedKeys = pathArr[pathArr.length - 1];
      let showMenu = menuList[model];
      if (model == 'Article' && !this.indexCache) {
        for (const i in showMenu) {
          if (showMenu[i].key === 'Pend') {
            showMenu.splice(i, 1);
          }
        }
      }
      if (model == 'Article') {
        if (
          (this.siteid != 16 && this.siteid != 6 && this.siteid != 18) ||
          this.role_id != 1
        ) {
          for (const i in showMenu) {
            if (showMenu[i].key == 'Map') {
              showMenu.splice(i, 1);
            }
          }
        }
      }
      const menu = {
        list: showMenu,
        defaultSelectedKeys: [defaultSelectedKeys]
      };
      this.$emit('setMenu', menu);
    }
  }
};
</script>

<style scoped>
.page-view {
  position: absolute;
  /*padding: 10px 15px;*/
  /*margin: 20px;*/
  /*top: 52px;*/
  /*overflow-y: scroll;*/
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /*top: 40px;*/
  /*right: 20px;*/
  /*bottom: 20px;*/
  /*left: 20px;*/
  /*background-color: #fff;*/
}
</style>
